// Smooth scrolling for navigation links
document.addEventListener('DOMContentLoaded', function () {
    // Set current year dynamically
    const currentYearElement = document.getElementById('current-year');
    if (currentYearElement) {
        currentYearElement.textContent = new Date().getFullYear();
    }
    // Get all navigation links
    const navLinks = document.querySelectorAll('a[href^="#"]');

    navLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            const targetSection = document.querySelector(targetId);

            if (targetSection) {
                const navHeight = document.querySelector('.navbar').offsetHeight;
                const targetPosition = targetSection.offsetTop - navHeight;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    // Navbar scroll effect
    const navbar = document.querySelector('.navbar');
    let lastScrollTop = 0;

    window.addEventListener('scroll', function () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 100) {
            navbar.style.background = 'rgba(255, 255, 255, 0.98)';
            navbar.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.1)';
        } else {
            navbar.style.background = 'rgba(255, 255, 255, 0.95)';
            navbar.style.boxShadow = 'none';
        }

        lastScrollTop = scrollTop;
    });

    // Intersection Observer for animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe feature cards for animation
    const featureCards = document.querySelectorAll('.feature-card');
    featureCards.forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(30px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(card);
    });

    // CTA button hover effects
    const ctaButtons = document.querySelectorAll('.cta-button');
    ctaButtons.forEach(button => {
        button.addEventListener('mouseenter', function () {
            this.style.transform = 'translateY(-3px) scale(1.02)';
        });

        button.addEventListener('mouseleave', function () {
            this.style.transform = 'translateY(0) scale(1)';
        });
    });

    // Mobile menu toggle (if needed for future enhancement)
    const mobileMenuToggle = document.createElement('button');
    mobileMenuToggle.innerHTML = '<i class="fas fa-bars"></i>';
    mobileMenuToggle.className = 'mobile-menu-toggle';
    mobileMenuToggle.style.display = 'none';

    // Add mobile styles for the toggle button
    const style = document.createElement('style');
    style.textContent = `
        .mobile-menu-toggle {
            background: none;
            border: none;
            font-size: 20px;
            color: #2563eb;
            cursor: pointer;
            padding: 8px;
        }

        .mobile-menu-toggle i {
            pointer-events: none;
        }

        @media (max-width: 768px) {
            .mobile-menu-toggle {
                display: block !important;
            }

            .nav-menu {
                display: none;
            }

            .nav-menu.active {
                display: flex;
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background: white;
                flex-direction: column;
                padding: 20px;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            }
        }
    `;
    document.head.appendChild(style);

    // Insert mobile toggle button
    const navContainer = document.querySelector('.nav-container');

    // Only insert if navContainer exists
    if (navContainer) {
        // Simple approach: just append to nav-container
        navContainer.appendChild(mobileMenuToggle);
    }

    // Mobile menu functionality
    mobileMenuToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const navMenu = document.querySelector('.nav-menu');
        navMenu.classList.toggle('active');

        if (navMenu.classList.contains('active')) {
            this.innerHTML = '<i class="fas fa-times"></i>';
        } else {
            this.innerHTML = '<i class="fas fa-bars"></i>';
        }
    });

    // Close mobile menu when clicking on a link
    const navMenuLinks = document.querySelectorAll('.nav-menu a');
    navMenuLinks.forEach(link => {
        link.addEventListener('click', function () {
            const navMenu = document.querySelector('.nav-menu');
            navMenu.classList.remove('active');
            mobileMenuToggle.innerHTML = '<i class="fas fa-bars"></i>';
        });
    });

    // Close mobile menu when clicking outside
    document.addEventListener('click', function (e) {
        const navMenu = document.querySelector('.nav-menu');
        const navContainer = document.querySelector('.nav-container');

        if (!navContainer.contains(e.target) && navMenu.classList.contains('active')) {
            navMenu.classList.remove('active');
            mobileMenuToggle.innerHTML = '<i class="fas fa-bars"></i>';
        }
    });

    // Form validation for future contact forms
    function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    // Add loading states to CTA buttons
    ctaButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            // Only add loading state if it's a form submission
            if (this.closest('form')) {
                e.preventDefault();
                const originalText = this.textContent;
                this.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Carregando...';
                this.disabled = true;

                // Simulate loading (remove this in production)
                setTimeout(() => {
                    this.textContent = originalText;
                    this.disabled = false;
                }, 2000);
            }
        });
    });

    // Pricing toggle functionality
    const billingToggle = document.getElementById('billing-toggle');
    const priceAmounts = document.querySelectorAll('.price-amount');
    const priceNotes = document.querySelectorAll('.price-note');

    if (billingToggle) {
        billingToggle.addEventListener('change', function () {
            const isAnnual = this.checked;

            priceAmounts.forEach(priceElement => {
                const monthlyPrice = priceElement.getAttribute('data-monthly');
                const annualPrice = priceElement.getAttribute('data-annual');

                if (isAnnual) {
                    priceElement.textContent = `R$ ${annualPrice}`;
                } else {
                    priceElement.textContent = `R$ ${monthlyPrice}`;
                }
            });

            // Update price notes separately
            priceNotes.forEach(noteElement => {
                if (isAnnual) {
                    noteElement.textContent = 'no plano anual';
                } else {
                    noteElement.textContent = 'no plano mensal';
                }
            });
        });
    }

    // Pricing card animations
    const pricingCards = document.querySelectorAll('.pricing-card');
    pricingCards.forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(30px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(card);
    });
});